import React from 'react'

import Message from 'react-bulma-components/lib/components/message'
import MessageHeader from 'react-bulma-components/lib/components/message/components/header'
import MessageBody from 'react-bulma-components/lib/components/message/components/body'
import ReactMarkdown from 'react-markdown'

export default ({ title, info, close }) => <div className='info-panel'>
  <Message color='info'>
    <MessageHeader>
      {title}
      <button className='delete' onClick={close} />
    </MessageHeader>
    <MessageBody>
      <ReactMarkdown>{info}</ReactMarkdown>
    </MessageBody>
  </Message>
</div>
